import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ProvidersList from "@/guiide/components/common/ProvidersList.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'LowCostDrawdown',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Low Cost Providers", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mx-auto col-md-9 mb-4 lead" }, " A number of our partners shown below offer low cost drawdown products. You can compare their expected costs over your retirement based on your specific plan built. You can also compare these against your current provider's charges using the slider. ", -1)),
    _createVNode(ProvidersList)
  ], 64))
}
}

})